import Actions from './actions';

const setCurrency = Actions.setCurrency;

export { setCurrency };
